import React from 'react';
import Appbarheader from './components/Appbar';
import Questionnaire from './components/Questionnaire';

const App =() => {
   return(
      <div>
         <Appbarheader />
         <Questionnaire />
      </div>
   )
}
export default App;